import { configureStore } from '@reduxjs/toolkit';

import { API } from '../api';
import session from './reducers/session';

const store = configureStore({
  reducer: {
    session,
    [API.reducerPath]: API.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(API.middleware)
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export { store };
